import React, { useState } from 'react';
import { Typography, Box, Dialog, DialogContent, IconButton } from '@mui/material';
import HighlightOff from '@mui/icons-material/HighlightOff';
import {
  HeroSection as StyledHeroSection,
  HeroContent,
  HeroTitle,
  HeroDescription,
  GetStartedButton
} from '../styles';

const HeroSection = () => {
  const [meetingDialogOpen, setMeetingDialogOpen] = useState(false);

  const handleGetStartedClick = () => {
    setMeetingDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setMeetingDialogOpen(false);
  };

  return (
    <>
      <StyledHeroSection>
        <HeroContent>
          <HeroTitle>
            Power your business with Agentic Commerce.
          </HeroTitle>
          <HeroDescription>
            Connect Logicbroker to intelligent, automated commerce partners starting with PayPal.
          </HeroDescription>
        </HeroContent>
        <GetStartedButton
          variant="outlined"
          onClick={handleGetStartedClick}
        >
          Get Started
        </GetStartedButton>
      </StyledHeroSection>
      {/* HubSpot Meeting Scheduler Dialog */}
      <Dialog
        open={meetingDialogOpen}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
        slotProps={{
          paper: {
            style: {
              height: '90vh',
              // maxHeight: '900px',
              width: '90vw',
              // maxWidth: '1400px',
            }
          }
        }}
      >
        {/* Dialog Header with Close Button */}
        <Box style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 24px',
          borderBottom: '2px solid #e0e0e0',
          backgroundColor: '#f5f5f5'
        }}>
          <Typography style={{
            fontSize: '20px',
            fontWeight: 600,
            fontFamily: 'Poppins',
            color: '#012237'
          }}>
            Schedule a Meeting with Our Team
          </Typography>
          <IconButton aria-label="close" onClick={handleCloseDialog} size="large">
            <HighlightOff style={{ color: 'red' }} />
          </IconButton>
        </Box>

        <DialogContent style={{ padding: 0, height: 'calc(100% - 70px)', overflow: 'hidden' }}>
          <iframe
            src="https://meetings.hubspot.com/nathan-wilmot?__hstc=216426761.3e947ea81d4a96b72daa76f61ba3ce30.1755531398632.1762967420673.1763403297506.6&__hssc=216426761.6.1763403297506&__hsfp=3732782242&submissionGuid=0b973492-71b5-4b84-ae71-f655be60cbf3&uuid=fa8f4389-3a85-4194-a284-05768c2bbe49"
            title="Schedule a Meeting"
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            allow="camera; microphone"
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HeroSection;